import * as React from 'react';
import { EventIndexView } from '../../../types/events';
import './eventCard.module.scss';
import moment from 'moment-timezone';
import classNames from 'classnames';
import { EventLocationLabel } from '../../atoms/locations/EventLocationLabel';
import { NewLabel } from '../../atoms/labels/NewLabel';
import { HashTagList } from '../../atoms/tags/HashTagList';

type Props = {
  event: EventIndexView;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: () => any;
  archived?: boolean;
};

export class EventCard extends React.Component<Props> {
  render() {
    const { event, onClick, archived = false } = this.props;
    const { starts_at, ends_at, archive_ends_at, published_at, tag_list } = event;
    const startsAt = moment(starts_at);
    const endsAt = moment(ends_at);
    const isSaturday = startsAt.isoWeekday() === 6;
    const isSunday = startsAt.isoWeekday() === 7;
    const archiveEndsAt = archive_ends_at ? moment(archive_ends_at) : null;
    const now = moment();
    const publishedAt = moment(published_at);
    const publishedWithinOneWeek = now.diff(publishedAt, 'days') <= 7;
    return (
      <>
        <div styleName="card-wrap">
          <div styleName="datetime">
            {archived ? (
              <>
                <div styleName="archive-date-wrap">
                  <span>開催：{startsAt.format('M月D日(ddd)')}</span>
                  <div styleName="archive-end-date">
                    {archiveEndsAt ? (
                      <span styleName="red">公開期限：{archiveEndsAt.format('M月D日(ddd)')}</span>
                    ) : (
                      <span>公開期限：なし</span>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div styleName="date">
                  <span styleName="date-no">{startsAt.format('M')}</span>月
                  <span styleName="date-no">{startsAt.format('D')}</span>日 (
                  <span styleName={classNames({ saturday: isSaturday, sunday: isSunday })}>
                    {startsAt.format('ddd')}
                  </span>
                  )
                </div>
                <div styleName="time-range">
                  {startsAt.format('HH:mm')} - {endsAt.format('HH:mm')}
                </div>
              </>
            )}
          </div>
          <div className="event-card" styleName="card" onClick={onClick} data-event-id={event.id}>
            <div styleName="thumbnail-wrapper">
              <img styleName="thumbnail" src={event.thumbnail_photo_url['original']} />
            </div>
            <div styleName="main">
              <div styleName="header">
                <EventLocationLabel location={event.location} />
                {publishedWithinOneWeek && <NewLabel />}
              </div>
              <div styleName="title">{event.title}</div>
              <HashTagList tags={tag_list} />
            </div>
          </div>
        </div>
      </>
    );
  }
}
